export default class ActiveCampaignClient {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.getActiveCampaignContact = this.getActiveCampaignContact.bind(this);
        this.postActiveCampaignRequest = this.postActiveCampaignRequest.bind(this);
    }
    getActiveCampaignContact(email, config) {
        return this.apiClient.get(`/v3/newsletter_requests/${email}`, config);
    }
    postActiveCampaignRequest(data, config) {
        return this.apiClient.post('/v3/newsletter_requests', data, config);
    }
}
